import type { IconProps } from '../types/IconProps.ts';
export const CircleArrowOutUpRight: IconProps = {
    name: 'CircleArrowOutUpRight',
    children: [
        `<path d="M16 2h5.5c.28 0 .5.22.5.5V8M13 11l8-8M22 12A10 10 0 1 1 12 2" />`,
    ]
};